module.exports = __webpack_public_path__ + "static/cover-fa93b5239699ac6960f5c254bd7585dc.png";